import reducer from './reducers'

// export { TypeKeys as genderConstants } from './constants';
// export { AuthenticationState } from './types'
export { default as authenticationSelector } from './selector'

export default reducer
